

const Loader = () => {
  return (
    <div class="spinner-border d-block mx-auto" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
  )
}

export default Loader
